import React, { FC, useState, useEffect, useRef } from 'react';
import { Input, Form } from 'antd';
import { Col, Row } from 'react-bootstrap';

const EquipmentLatestDataFilter: FC<any> = (props) => {
  const { Search } = Input;
  const { filters, handleOnChanged } = props;
  const [searchValue, setSearchValue] = useState('');
  const lastSearchValue = useRef('');

    useEffect(() => {
        const shouldSearch = 
            (searchValue.length >= 3 && searchValue !== lastSearchValue.current) || 
            (searchValue === '' && lastSearchValue.current !== '');

        if (shouldSearch) {
            const timer = setTimeout(() => {
                handleOnChanged('search', searchValue);
                lastSearchValue.current = searchValue;
            }, 500);

            return () => clearTimeout(timer);
        }
    }, [searchValue, handleOnChanged]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value);
    };

    return (
        <div className='p-6'>
            <Row gutter={[16, 16]}>
                <Col md={9} xs={12}>
                    <div className='card card-header p-0 pb-3' style={{ minHeight: "0px" }}>
                        <h3 className='card-title align-items-start flex-column'>
                            <span className='card-label fw-bold fs-3 mb-1'>Recent Data</span>
                        </h3>
                    </div>
                </Col>
                <Col md={3} xs={12}>
                    <Form.Item name="search">
                        <Search 
                            placeholder="Type 3+ chars to search" 
                            value={searchValue}
                            onChange={handleChange}
                            allowClear
                            onSearch={(value) => handleOnChanged('search', value)}
                        />
                    </Form.Item>
                </Col>
            </Row>
        </div>
    );
};

export default React.memo(EquipmentLatestDataFilter);